import React from 'react';

import { RenderActionTitle } from './RenderActionTitle';

import circlePlusImg from '../../../assets/images/circlePlus.png';
import TenantConfig from '../../../config';

export const RenderButtonsFn = (propsForRenderButton) => {
  const {
    isMainApplicant,
    sectionError,
    handleAddBusinessOwner,
    updateAndValidateProperty,
    handleSkip,
    handleContinue,
    getCurrentFeature,
    appData,
  } = propsForRenderButton;
  const tenantName = TenantConfig.getTenant();
  const isEdit = new URLSearchParams(location.search).get('edit');
  const currentFeature = getCurrentFeature();
  const showSkipButton = () => {
    let uploadDocsDisabledForTenant;
    if (TenantConfig?.settings?.isUploadDocumentsLaterButtonEnabled == null) {
      uploadDocsDisabledForTenant = true;
    } else {
      uploadDocsDisabledForTenant = TenantConfig?.settings?.isUploadDocumentsLaterButtonEnabled;
    }

    return (
      currentFeature?.itemType === 'FileProperty' &&
      appData.phase === 'PRE_SUBMISSION' &&
      uploadDocsDisabledForTenant
    );
  };

  const showSaveAndContinueButton = () => {
    if (showSkipButton()) {
      return false;
    } else {
      if (!!TenantConfig?.settings?.isSaveAndContinueButtonEnabled === false) {
        return false;
      } else {
        switch (currentFeature?.dataType) {
          case 'plaidtoken':
            if (isEdit || currentFeature?.valueValidated) {
              return false;
            }
            return true;
          case 'financialinstrument':
          case 'loanPurposeDetails':
          case 'license':
            return false;
          default:
            return true;
        }
      }
    }
  };

  const showSubmitButton = () => {
    switch (currentFeature?.dataType) {
      case 'idVerify':
        return (
          currentFeature?.value[0]?.status === 'COMPLETED' ||
          currentFeature?.value[0]?.status === 'APPROVED'
        );
      case 'plaidtoken':
      case 'financialinstrument':
      case 'loanPurposeDetails':
      case 'license':
        return false;
      default:
        return true;
    }
  };

  return (
    <div>
      {currentFeature &&
        currentFeature.limits &&
        currentFeature.limits.maximum > 1 &&
        currentFeature.itemType !== 'FileProperty' && (
          <p className="description">
            <strong>{currentFeature?.displayProperties?.meta?.LINE1} </strong>{' '}
            {currentFeature?.displayProperties?.meta?.LINE2}
          </p>
        )}
      {sectionError && <p className="section-error">{sectionError}</p>}
      <div className={'d-flex bottom-actions align-items-center justify-content-around'}>
        {currentFeature &&
          currentFeature.limits &&
          currentFeature.limits.maximum > 1 &&
          currentFeature.itemType !== 'FileProperty' &&
          isMainApplicant && (
            <button className="d-flex add-owner-btn" onClick={handleAddBusinessOwner}>
              <img src={circlePlusImg} alt="" />
              <span>
                Add Another{' '}
                {currentFeature.limits.unitText ? currentFeature.limits.unitText : 'Owner'}
              </span>
            </button>
          )}
        <div className="d-flex">
          {showSaveAndContinueButton() ? (
            <button onClick={() => updateAndValidateProperty(true)} className="primary-btn">
              Save and Continue Later
            </button>
          ) : (
            ''
          )}
          {showSkipButton() ? (
            <button onClick={handleSkip} className="primary-btn btn">
              Upload Documents Later
            </button>
          ) : (
            ''
          )}
          {showSubmitButton() ? (
            <button onClick={() => handleContinue()} className="primary-btn btn" id="continue-btn">
              {RenderActionTitle({ getCurrentFeature, isEdit, tenantName })}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};
